var _linearGradient, _linearGradient2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrafficAverageDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 332,
    height: 129,
    viewBox: "0 0 332 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "04x457ojsa",
    x1: 0.776,
    y1: -0.345,
    x2: 0.393,
    y2: 1.189,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e69e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffda5f",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "zvt9otdz3c",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#04x457ojsa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "yawplbbgyb"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2859",
    width: 332,
    height: 129,
    rx: 16,
    transform: "translate(-8523 -11790)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Insight Card Inside Graphic",
    transform: "translate(8523 11790)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate",
      clipPath: "url(#yawplbbgyb)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2787"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1292",
    d: "M0 122.654 61.9 47.12a2.009 2.009 0 0 1 3-.116L89 72.175a2.009 2.009 0 0 0 3.134-.3l28.908-44.541a2.009 2.009 0 0 1 1.684-.913h31.272a2.009 2.009 0 0 0 1.646-.856L172.948.856a2.01 2.01 0 0 1 3.359.1l35.087 45.931v75.763z",
    transform: "translate(-8392.363 -11778.654)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "url(#04x457ojsa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1293",
    d: "M211.413 122.654V46.891L176.326.96a2.01 2.01 0 0 0-3.359-.1l-17.294 24.71a2.009 2.009 0 0 1-1.646.856h-31.272a2.009 2.009 0 0 0-1.684.913L92.163 71.88a2.009 2.009 0 0 1-3.134.295L64.927 47a2.009 2.009 0 0 0-3 .116L.019 122.654h211.394m3.009 3H-6.325l65.917-80.432a5.024 5.024 0 0 1 7.511-.289l23.224 24.254 28.218-43.477a5 5 0 0 1 4.21-2.283H153.5l17-24.288A5.023 5.023 0 0 1 174.611-3a4.982 4.982 0 0 1 4.183 2.24l35.627 46.639z",
    transform: "translate(-8392.383 -11778.654)",
    style: {
      fill: "url(#zvt9otdz3c)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficAverageDay);
export default __webpack_public_path__ + "static/media/traffic-average-day.e4f4670bcb96d7a47bae012d0a942c42.svg";
export { ForwardRef as ReactComponent };